export default __webpack_public_path__ + "static/media/ServerError.5a1559d8.svg";